export class ConfiguracoesForm {
  public static aprovaCliente;
  public static produtoDetalhe

  public static patchAppConfig(c) {
    this.aprovaCliente = c.aprovaCliente;
    this.produtoDetalhe = c.produtoDetalhe
  }
}
